import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../comum/Titulo';
import {PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {buscarCupons, buscarTipos, determinarPaginaAtualCupons, excluirCupom, inativarCupom, alterarRegistrosPorPaginaCupons, buscarOrigensRequisicaoCupom} from '../../actions/cupom/cuponsActions'
import buscarPlataformas from '../../actions/empresa/buscarPlataformas';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import {showSuccessMsg} from '../../util/messagesUtil';
import Cupom from './Cupom';
import PaginacaoCupom from './PaginacaoCupom';
import BotoesPaginacaoCupom from './BotoesPaginacaoCupom';
import ModalCadastrarCupom from './ModalCadastrarCupom';
import PainelFiltragem from '../cupom/PainelFiltrosCupom';
import {alterouFiltro, alterouPagina} from '../../util/filtros';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col">Data de criação</div>
            <div className="col">Válido</div>
            <div className="col">Identificação</div>
            <div className="col">Tipo</div>
            <div className="col">Plataforma</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoExclusaoCupom = ({excluir, inativarCupom, cupom}) => {
    const cupomFoiUtilizado = cupom ? cupom.quantidadeUtilizada : null
    if(cupomFoiUtilizado == 0 || cupomFoiUtilizado == null) {
        return <div className="modal fade" id="modalConfirmacaoExclusaoCupom" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir o cupom com identificação: <strong>{cupom ? cupom.identificacao : ''}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>} 
    if(cupomFoiUtilizado > 0) {
            return <div className="modal fade" id="modalConfirmacaoExclusaoCupom" tabIndex="-1" role="dialog"
            aria-labelledby="modalConfirmacao" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body texto-centralizado">
                        <p>Não é possível excluir o cupom <strong>{cupom ? cupom.identificacao : ''}</strong> porque ele já foi utilizado em uma reserva. Deseja inativá-lo?</p>
                    </div>
                    <div className="modal-footer ">
                        <button id='cancelar' type="button" className="btn btn-outline-secondary"
                                data-dismiss="modal">Cancelar
                        </button>
                        <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                                onClick={() => inativarCupom()}>Inativar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
    
    
};

export class PainelGerenciarCupom extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarCupom = this.selecionarCupom.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.inativarCupom = this.inativarCupom.bind(this);
        this.buscarCupons = this.buscarCupons.bind(this);
        this.state = {
            cupomSelecionado: null,
            textoFiltro: null,
            parametros: {}
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualCupons(1)
    }

    componentDidMount() {
        this.buscarCupons();
        this.props.buscarTipos();
        this.props.buscarPlataformas();
        this.props.buscarOrigensRequisicaoCupom();

    }

    buscarCupons() {
        this.props.buscarCupons(this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtualCupons(1);
                this.props.alterarRegistrosPorPaginaCupons(10);
            }
            this.buscarCupons();
        }
    }

    selecionarCupom(cumpom) {
        this.setState({cupomSelecionado: cumpom});
    }

    inativarCupom() {
        this.props.inativarCupom(this.state.cupomSelecionado.id)
                .then(() => {
                    showSuccessMsg('Cupom inativado com sucesso!');
                    this.buscarCupons();
            })
    }

    excluir() {
        this.props.excluirCupom(this.state.cupomSelecionado.id)
            .then(() => {
                showSuccessMsg('Cupom excluído com Sucesso!');
                this.buscarCupons();
            })
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroCupom',
            'idPreco', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataInicio', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataFim', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'identificacao', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'email', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'tipo', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'plataforma', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'quantidade', '');
        this.props.changeFieldValue('origemRequisicao',
            'origemRequisicao', '');
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoCupom() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button data-toggle="modal" data-target="#modalCadastrarCupom" className="btn btn-laranja">
                                Novo Cupom
                            </button>
                        </div>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirTabelaCupons() {
        const {cupons} = this.props
        if (cupons && cupons.length) {
            return (<div className="col-12 conteudo-internas">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoCupom}
                                           BotoesPaginacao={BotoesPaginacaoCupom}
                                           cupom={cupons}>
                        <CabecalhoTabela/>
                        <div className="lista-table">
                            {this.exibirCupons()}
                        </div>
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return <div>Nenhum cupom cadastrado.</div>;
    }

    exibirCupons() {
        const {cupons} = this.props
        if (cupons) {
            return cupons.map((cupom, index) => <Cupom key={index} cupom={cupom}
                                                       selecionarCupom={this.selecionarCupom}
                                                       cupomSelecionado={this.state.cupomSelecionado}
                                                       indice={index}
                                                       buscarCupons={this.buscarCupons}
                                                       />)
        }
    }

    exibirFiltro() {
        return <div className="row">
            <div className="col-md-12">
                <div className="text-right">
                    <PainelFiltragem/>
                </div>
            </div>
        </div>
    }


    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Cupons" urlRetorno="/cupom"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirFiltro()}
                            {this.exibirBotaoNovoCupom()}
                            {this.exibirTabelaCupons()}
                        </div>
                    </div>
                    <ModalCadastrarCupom selecionarCupom={this.selecionarCupom} buscarCupons={this.buscarCupons} cupom={this.state.cupomSelecionado} />
                    <ModalConfirmacaoExclusaoCupom excluir={this.excluir} inativarCupom={this.inativarCupom} cupom={this.state.cupomSelecionado}/>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    return{
        cupons: state.cupom.cupons,
        changeFieldValue,
        paginaAtual: state.cupom.paginaAtualCupons,
        registrosPorPagina: state.cupom.registrosPorPaginaCupons,
        filtrosAdicionados: state.filtrosAdicionadosCupom

    }};


export default connect(mapStateToProps, {
    determinarPaginaAtualCupons,
    alterarRegistrosPorPaginaCupons,
    buscarTipos,
    buscarCupons,
    buscarPlataformas,
    excluirCupom,
    inativarCupom,
    buscarOrigensRequisicaoCupom
})(reduxForm({
    form: 'formularioCadastroCupom'
})(PainelGerenciarCupom))
